import React, { useState, useEffect } from "react";
import { Icon, Image, Grid, GridRow, GridColumn } from "semantic-ui-react";
import { ENV, buildStorageUrl } from "../../../../../../utils";
import ReactAudioPlayer from "react-audio-player";
import "../TemplateManager.scss";

export const Smu03 = React.memo((props) => {
  const { slideId, activeSession } = props;
  const [title, setTitle] = useState("");
  const [titleAudio, setTitleAudio] = useState("");
  const [image, setImage] = useState("");
  const [audio, setAudio] = useState(null);
  const [titleAudio2, setTitleAudio2] = useState("");
  const [image2, setImage2] = useState("");
  const [audio2, setAudio2] = useState(null);

  /**
   * Synchronizes component state with the content of the currently selected slide in Smu03.js.
   *
   * This `useEffect` hook is executed whenever the `slideId` changes. It searches the `activeSession.slides`
   * array for a slide that matches the `slideId`. If such a slide is found and it contains content, specifically
   * in the `audios` array, the hook updates the component's state with the slide's title and details of the first
   * two audios including their images, titles, and audio URLs.
   *
   * Specifically, it performs the following actions:
   * - Sets the `title` state with the slide's content title.
   * - For the first audio:
   *   - Sets the `image` state with its image URL.
   *   - Sets the `titleAudio` state with its title.
   *   - Sets the `audio` state with its audio URL.
   * - For the second audio:
   *   - Sets the `image2` state with its image URL.
   *   - Sets the `titleAudio2` state with its title.
   *   - Sets the `audio2` state with its audio URL.
   *
   * This ensures that the component accurately represents the content of the current slide, allowing for
   * effective editing and previewing within an active session. It provides a detailed view of the slide's content,
   * focusing on the first two audios to enhance user engagement and content interaction.
   *
   * @dependency slideId - The ID of the current slide, changes to which trigger the hook.
   */
  useEffect(() => {
    const slide = activeSession.slides.find((slide) => slide._id === slideId);
    if (slide && slide.content) {
      setTitle(slide.content.title);
      setImage(slide.content.audios[0].image);
      setTitleAudio(slide.content.audios[0].title);
      setAudio(slide.content.audios[0].audio);
      setImage2(slide.content.audios[1].image);
      setTitleAudio2(slide.content.audios[1].title);
      setAudio2(slide.content.audios[1].audio);
    }
  }, [slideId]);

  return (
    <div className="row">
      <h3 className="show-slide__title">
        <Icon name="bookmark" />
        {title}
      </h3>
      <div className="show-slide__body">
        <Grid columns={2} divided>
          <GridRow>
            <GridColumn>
              <Image bordered rounded fluid src={buildStorageUrl(image)} />
              <h4 className="show-slide__title">
                <Icon name="bookmark" />
                {titleAudio}
              </h4>
              <div className="media-slide__input-audio">
                <ReactAudioPlayer
                  src={buildStorageUrl(audio?.preview)}
                  controls
                  controlsList="nodownload"
                />
              </div>
            </GridColumn>
            <GridColumn>
              <Image
                bordered
                rounded
                fluid
                src={buildStorageUrl(image2)}
              />
              <h4 className="show-slide__title">
                <Icon name="bookmark" />
                {titleAudio2}
              </h4>
              <div className="media-slide__input-audio">
                <ReactAudioPlayer
                  src={buildStorageUrl(audio2?.preview)}
                  controls
                  controlsList="nodownload"
                />
              </div>
            </GridColumn>
          </GridRow>
        </Grid>
      </div>
    </div>
  );
});
